import en from './en';
import cn from './cn';
import tw from './tw';
import jp from './jp';
import { get } from 'lodash';

let lang = 'en';

const localMap = {
    'en-US': 'en',
    'zh-CN': 'cn',
    'zh-TW': 'tw',
    'ja-JP': 'jp',
};

const messages = { en, cn, tw, jp };
export function setLang(_lang: 'en' | 'cn' | 'tw' | 'jp' | 'en-US' | 'zh-CN' | 'zh-TW' | 'ja-JP') {
    // @ts-ignore
    lang = localMap[_lang] || _lang;
}

export function $t(key: string): string {
    // @ts-ignore
    return get(messages[lang], key) || key;
}
export function getLang(): string {
    return lang;
}
